import React, { useState } from "react";
import uniqBy from "lodash/uniqBy"

// reactstrap components
import {
  Table,
  Button,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  // UncontrolledDropdown,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col
} from "reactstrap";

const Variations = ({
  varType, 
  varValue, 
  varAmount, 
  varAmountMYR,
  setVarType, 
  setVarValue, 
  setVarAmount, 
  setVarAmountMYR,
  variationArray, 
  pushVariation, 
  variationMove,
  removeVariation,
  updateVariation,
}) => {
  const [editingIndex, setEditingIndex] = useState(null)
  const [editData, setEditData] = useState({})

  const startEdit = (index, variation) => {
    setEditingIndex(index)
    setEditData({
      type: variation.type,
      value: variation.value,
      amount: variation.amount || 0,
      amountMYR: variation.amountMYR || 0
    })
  }

  const cancelEdit = () => {
    setEditingIndex(null)
    setEditData({})
  }

  const saveEdit = (index) => {
    if(editData.type && editData.value && (!isNaN(editData.amount) && (editData.amount >= 0)) && (!isNaN(editData.amountMYR) && (editData.amountMYR >= 0))){
      updateVariation(index, {
        type: editData.type.toLowerCase(),
        value: editData.value.toLowerCase(),
        amount: editData.amount || 0,
        amountMYR: editData.amountMYR || 0
      })
      setEditingIndex(null)
      setEditData({})
    }
  }

  return (  
    <>
      <Card className="shadow mb-3">
        <CardHeader className="bg-secondary">Variations</CardHeader>
        <CardBody>
          <Row className="mb-2">
            <Col md="4">
              <div>
                <small className="text-uppercase font-weight-bold">
                  Type
                </small>
              </div>
              {/* <UncontrolledDropdown nav inNavbar className="w-100">
                <DropdownToggle caret color="secondary" className="w-100 text-capitalize">
                  {varType.split('_').join(' ')}
                </DropdownToggle>
                <DropdownMenu className="w-100">
                  <div className="editInputs-colors-scrollbar mac-scrollbar">
                    <DropdownItem 
                      className="text-capitalize" 
                      value="anodizing_color" 
                      onClick={() => setVarType("anodizing_color")}
                    >
                      Anodizing Color
                    </DropdownItem>
                    <DropdownItem 
                      className="text-capitalize" 
                      value="carbon_fiber_finish" 
                      onClick={() => setVarType("carbon_fiber_finish")}
                    >
                      Carbon Fiber Finish
                    </DropdownItem>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown> */}
              <Input
                placeholder="exp. anodizing_color..."
                type="text"
                className="input-group-alternative"
                value={varType}
                onChange={(e) => setVarType(e.target.value)}
              />
              Exp: anodizing_color, carbon_fiber_finish
            </Col>
            <Col md="4">
              <div>
                <small className="text-uppercase font-weight-bold">
                  Value
                </small>
              </div>
              <Input
                placeholder="exp. Red, Yellow..."
                type="text"
                className="input-group-alternative"
                value={varValue}
                onChange={(e) => setVarValue(e.target.value)}
              />
            </Col>
            <Col md="2">
              <div>
                <small className="text-uppercase font-weight-bold">
                  Price USD
                </small>
              </div>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-money-coins" />
                  </InputGroupText>
                </InputGroupAddon>
                  <Input
                    placeholder="USD"
                    type="number"
                    className="input-group-alternative"
                    value={varAmount}
                    onChange={(e) => setVarAmount(e.target.value)}
                    onWheel={ event => event.currentTarget.blur() }
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md="2">
              <div>
                <small className="text-uppercase font-weight-bold">
                  Price MYR
                </small>
              </div>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-money-coins" />
                  </InputGroupText>
                </InputGroupAddon>
                  <Input
                    placeholder="MYR"
                    type="number"
                    className="input-group-alternative"
                    value={varAmountMYR}
                    onChange={(e) => setVarAmountMYR(e.target.value)}
                    onWheel={ event => event.currentTarget.blur() }
                  />
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row className="justify-content-center pt-2">
            <Col md="8">
              <FormGroup>
                <Button
                  className="m-0 mb-1 w-100"
                  color="secondary"
                  type="button"
                  onClick={() => pushVariation(varType, varValue, varAmount, varAmountMYR)}
                >
                  <div className="btn-inner--text">
                    <span>Add Variety</span>
                  </div>
                </Button>
              </FormGroup>
            </Col>
          </Row>
          {variationArray.length > 0?
            uniqBy(variationArray, "type").map((uniType, uniIndex) => {
              return (
                <div key={uniIndex} className="mt-2">
                  <Card className="bg-default shadow">
                    <CardHeader className="bg-transparent border-0 text-white text-uppercase">
                      {uniType.type.split('_').join(' ')}
                    </CardHeader>
                    <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      <Table className="align-items-center table-dark table-flush" style={{ minWidth: '600px' }}>
                      <thead className="thead-dark">
                        <tr>
                          <th style={{ width: '60px', minWidth: '60px' }}>Move</th>
                          <th style={{ width: '120px', minWidth: '120px' }}>Type</th>
                          <th style={{ width: '120px', minWidth: '120px' }}>Value</th>
                          <th style={{ width: '100px', minWidth: '100px' }}>USD</th>
                          <th style={{ width: '100px', minWidth: '100px' }}>MYR</th>
                          <th style={{ width: '80px', minWidth: '80px' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {variationArray.map((v, i) => {
                          if(v.type === uniType.type){
                            return (
                              <tr key={i} className="text-uppercase">
                                <th scope="row" style={{ width: '60px', padding: '8px 4px' }}>
                                  <div className="d-flex flex-column align-items-center">
                                    <div className="cursor-pointer mb-1" onClick={()=>variationMove(variationArray, i, i-1)}>
                                      <i className="ni ni-bold-up" style={{ fontSize: '0.8rem' }}></i>
                                    </div>
                                    <div className="cursor-pointer" onClick={()=>variationMove(variationArray, i, i+1)}>
                                      <i className="ni ni-bold-down" style={{ fontSize: '0.8rem' }}></i>
                                    </div>
                                  </div>
                                </th>
                                {editingIndex === i ? (
                                  <>
                                    <td style={{ padding: '4px' }}>
                                      <Input
                                        size="sm"
                                        value={editData.type || ''}
                                        onChange={(e) => setEditData({...editData, type: e.target.value})}
                                        placeholder="Type"
                                        style={{ fontSize: '0.75rem', padding: '4px 6px' }}
                                      />
                                    </td>
                                    <td style={{ padding: '4px' }}>
                                      <Input
                                        size="sm"
                                        value={editData.value || ''}
                                        onChange={(e) => setEditData({...editData, value: e.target.value})}
                                        placeholder="Value"
                                        style={{ fontSize: '0.75rem', padding: '4px 6px' }}
                                      />
                                    </td>
                                    <td style={{ padding: '4px' }}>
                                      <Input
                                        size="sm"
                                        type="number"
                                        value={editData.amount || ''}
                                        onChange={(e) => setEditData({...editData, amount: e.target.value})}
                                        placeholder="USD"
                                        style={{ fontSize: '0.75rem', padding: '4px 6px' }}
                                      />
                                    </td>
                                    <td style={{ padding: '4px' }}>
                                      <Input
                                        size="sm"
                                        type="number"
                                        value={editData.amountMYR || ''}
                                        onChange={(e) => setEditData({...editData, amountMYR: e.target.value})}
                                        placeholder="MYR"
                                        style={{ fontSize: '0.75rem', padding: '4px 6px' }}
                                      />
                                    </td>
                                    <td style={{ padding: '4px', textAlign: 'center' }}>
                                      <div className="d-flex justify-content-center">
                                        <i 
                                          className="ni ni-check-bold text-success mr-1"
                                          style={{fontSize: '0.9rem', cursor:'pointer'}}
                                          onClick={() => saveEdit(i)}
                                          title="Save"
                                        ></i>
                                        <i 
                                          className="ni ni-fat-remove text-danger"
                                          style={{fontSize: '0.9rem', cursor:'pointer'}}
                                          onClick={cancelEdit}
                                          title="Cancel"
                                        ></i>
                                      </div>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td style={{ padding: '8px 4px', wordBreak: 'break-word', fontSize: '0.8rem' }}>
                                      {v.type.split('_').join(' ')}
                                    </td>
                                    <td style={{ padding: '8px 4px', wordBreak: 'break-word', fontSize: '0.8rem' }}>
                                      {v.value}
                                    </td>
                                    <td style={{ padding: '8px 4px', fontSize: '0.75rem' }}>
                                      <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v.amount || 0)}</span>
                                    </td>
                                    <td style={{ padding: '8px 4px', fontSize: '0.75rem' }}>
                                      <span>{new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(v.amountMYR || 0)}</span>
                                    </td>
                                    <td style={{ padding: '4px', textAlign: 'center' }}>
                                      <div className="d-flex justify-content-center">
                                        <i 
                                          className="ni ni-ruler-pencil text-primary mr-1"
                                          style={{fontSize: '0.9rem', cursor:'pointer'}}
                                          onClick={() => startEdit(i, v)}
                                          title="Edit"
                                        ></i>
                                        <i 
                                          className="ni ni-fat-remove text-danger"
                                          style={{fontSize: '0.9rem', cursor:'pointer'}}
                                          onClick={() => removeVariation(i)}
                                          title="Delete"
                                        ></i>
                                      </div>
                                    </td>
                                  </>
                                )}
                              </tr>
                            )
                          }else{
                            return false
                          }
                        })}
                      </tbody>
                    </Table>
                    </div>
                  </Card>
                </div>
              )
            }):null}
        </CardBody>
      </Card>
    </>
  );
}
 
export default Variations;